export function formatBirthdate(raw: string | null): string {
  if (!raw) return "-";
  if (/^\d{8}$/.test(raw)) {
    return `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}`;
  }
  return raw;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return "-";
  return new Date(iso).toLocaleString("ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * 제출 일시 — submittedAt 이 정본. 서버가 유도까지 마쳐 내려주므로 정상 응답은 항상 값이 있다.
 * createdAt 은 응모 폼 초안이 처음 자동저장된 시각이라 실제 제출일보다 며칠 이를 수 있어,
 * 값이 비는 예외 상황(draft 등)에서만 최후 폴백으로 쓴다.
 */
export function formatSubmittedAt(submission: {
  submittedAt: string | null;
  createdAt: string;
}): string {
  return formatDateTime(submission.submittedAt ?? submission.createdAt);
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  const value = bytes / Math.pow(k, i);
  return `${value.toFixed(i === 0 ? 0 : 2)} ${sizes[i]}`;
}
